import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { AlertaInformativaComponent } from '../../shared/components/alerta-informativa/alerta-informativa.component';

@Component({
    selector: 'app-token-expiration-modal',
    templateUrl: './token-expiration-modal.component.html',
    styleUrls: ['./token-expiration-modal.component.css'],
    imports: [MatDialogTitle, MatDialogContent, AlertaInformativaComponent, MatDialogActions, MatButton, MatIcon]
})
export class TokenExpirationModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TokenExpirationModalComponent>,

  ) {}

  cerrarModal(resultado: boolean) {
    this.dialogRef.close(resultado); // Cierra el modal
  }
}
